import en from "./en.json";
import al from "./al.json";
import mk from "./mk.json";

const getStrings = (screen: any, lang: string) => {
	if (lang && lang === "al") {
		return al[screen as keyof typeof al];
	} else if (lang && lang === "en") {
		return en[screen as keyof typeof en];
	} else {
		return mk[screen as keyof typeof mk];
	}
};

export default getStrings;
